module.exports = __webpack_public_path__ + "img/student_male.1ecceafd.png";